module.exports = __webpack_public_path__ + "img/top.2a7f93d0.png";